import React, { useContext, useEffect, useState } from "react";
import LoanRepaymentLogo from "../../../Assets/Images/LoanRepayment.svg";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { Tooltip, Typography } from "@mui/material";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  GetDemandRecoveryDashboard,
  getRePaymentHistory,
} from "../../../Helpers/APIEndPoints/EndPoints";
import OverflowTip from "../../../Components/OverflowToolTip/OverflowToolTip";
import moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../../../Helpers/Constants/Constants";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { useDispatch } from "react-redux";
import { setIsLoanParams } from "../../../Redux/Actions/LoanModuleAction";
import Modal from "react-modal";
import { IDDRGrid } from "./IDDRGrid";
Modal.setAppElement("#root"); // Set the root element for accessibility

const DRRGrid = (props: IDDRGrid) => {
  const {
    searchText,
    setSearchText,
    activeTab,
    currentFilters,
    dataCount,
    setDataCount,
    setCurrentDataReqObj,
  } = props;
  const context = getContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { showLoader, hideLoader } = useContext(LoaderContext);

  const [sortDirection, setSortDirection] = useState("");
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");

  const [historyStart, setHistoryStart] = useState(0);
  const [historyPageSize] = useState(10);
  const [historySortDirection, setHistorySortDirection] = useState("");
  const [historySortColumn, setHistorySortColumn] = useState("");
  const [historyCount, setHistoryCount] = useState(0);

  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardHistoryData, setDashboardHistoryData] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  useEffect(() => {
    dispatch(setIsLoanParams({ LoanId: 0, MemberId: 0 }));
  }, []);

  const generateDummyData = () => {
    const dummyData = [];
    const numberOfRecords = 10; // Define the number of dummy records you want

    for (let i = 0; i < numberOfRecords; i++) {
      const record = {
        MemberNumber: `Member-${i + 1}`,
        tokenNo: `Token-${i + 1}`,
        Name: `Name ${i + 1}`,
        StartDate: `Start Date ${i + 1}`,
        EndDate: `End Date ${i + 1}`,
        DemandType: `Demand Type ${i + 1}`,
        RecoverableAmount: `Recoverable Amount ${i + 1}`,
        PostingPeriod: `Posting Period ${i + 1}`,
        share1: `Share 1 ${i + 1}`,
        share2: `Share 2 ${i + 1}`,
        cd: `CD ${i + 1}`,
        fd: `FD ${i + 1}`,
        AdditionalFd: `Additional FD ${i + 1}`,
        mbf: `MBF ${i + 1}`,
        sl: `SL ${i + 1}`,
        sli: `SLI ${i + 1}`,
        ll: `LL ${i + 1}`,
        lli: `LLI ${i + 1}`,
        al: `AL ${i + 1}`,
        ali: `ALI ${i + 1}`,
        pi: `PI ${i + 1}`,
        sc: `SC ${i + 1}`,
        od: `OD ${i + 1}`,
        excessRecovery: `Excess Recovery ${i + 1}`,
        shortRecovery: `Short Recovery ${i + 1}`,
        SuretyRecovery: `Surety Recovery ${i + 1}`,
        MonthlyCont: `Monthly Cont ${i + 1}`,
        CGST: `CGST ${i + 1}`,
        SGST: `SGST ${i + 1}`,
        IGST: `IGST ${i + 1}`,
        CompanyCutoff: `Company Cutoff ${i + 1}`,
        StatusForDemand: `Status For Demand ${i + 1}`,
        FinancialYear: `Financial Year ${i + 1}`,
        Balance: `Balance ${i + 1}`,
        // You can add more fields here if needed
      };

      dummyData.push(record);
    }

    return dummyData;
  };

  const getDashboardData = async () => {
    showLoader();
    try {
      let statusIds;
      setCurrentDataReqObj(null);

      let unitCodeIds = "";
      // if (context?.CurrentRoleId === RoleEnum.InternalTeam) {
      unitCodeIds = context?.UnitCodeIds;
      // }
      const filterUnitCodeIds = currentFilters?.unitCode?.map((v) => v?.value);
      if (filterUnitCodeIds?.length > 0) {
        unitCodeIds = filterUnitCodeIds?.join(",");
      }
      
      let obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        MemberId:
          (context?.loggedInAs?.value as RoleEnum) === RoleEnum.Member
            ? context?.MemberId
            : 0,
        // MemberId: context?.MemberId,
        UnitCodeId: unitCodeIds,
        TypeofApplicantId:
          currentFilters?.typeofApplicant?.map((v) => v?.value)?.join(",") ||
          "",
        FromDate: currentFilters?.fromDate || "",
        ToDate: currentFilters?.toDate || "",
        Status: statusIds,
      };

      setCurrentDataReqObj(obj);
      const resp = await APICall(GetDemandRecoveryDashboard, obj);

      if (resp?.Data?.length > 0) {
        setDashboardData(resp?.Data);
      } else {
        // setDashboardData(generateDummyData());
        setDashboardData([]);
        hideLoader();
      }

      const dataCount = resp?.Data[0]?.TotalCount || resp?.Data?.length || 0;
      setDataCount(dataCount);
    } catch (err) {
      // notify(
      //   ToastType.Error,
      //   "It seems there server is down right now, Please try again later."
      // );
     
    } finally {
      hideLoader();
    }
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    //0
    // {
    //   name: "PostingPeriod",
    //   label: "Posting Period",
    //   options: {
    //     ...CommonCellOptions(),
    //     // display: context?.CurrentRoleId === RoleEnum.Admin,
    //     display: true,
    //   },
    // },
    //1
    {
      name: "MemberNumber",
      label: "Member No",
      options: CommonCellOptions(),
    },
    //2
    {
      name: "TokenNo",
      label: "Token No",
      options: CommonCellOptions(),
    },
    //3
    {
      name: "Name",
      label: "Name",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //4
    {
      name: "DemandRecoveryDate",
      label: "Demand/Recovery Date",
      options: {
        ...CommonCellOptions(true),
        display: true,
      },
    },
    // {
    //   name: "StartDate",
    //   label: "StartDate",
    //   options: {
    //     ...CommonCellOptions(true),
    //     display: true,
    //   },
    // },
    // //5
    // {
    //   name: "EndDate",
    //   label: "EndDate",
    //   options: {
    //     ...CommonCellOptions(true),
    //     display: true,
    //   },
    // },
    //6
    {
      name: "DemandType",
      label: "DemandType",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //7
    {
      name: "RecoverableAmount",
      label: "Recoverable Amount",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //8
    // {
    //   name: "PostingPeriod",
    //   label: "Posting Period",
    //   options: {
    //     ...CommonCellOptions(),
    //     display: true,
    //   },
    // },
    //9
    {
      name: "Share1",
      label: "Share 1",
      options: { display: true },
    },
    //10
    {
      name: "Share2",
      label: "Share 2",
      options: { display: true },
    },
    //11
    {
      name: "CD",
      label: "CD",
      options: { display: true },
    },
    //12
    {
      name: "FD",
      label: "FD",
      options: { display: true },
    },
    //13
    {
      name: "AdditionalFD",
      label: "Additional FD",
      options: { display: true },
    },
    //14
    {
      name: "MBF",
      label: "MBF",
      options: { display: true },
    },
    //15
    {
      name: "SL",
      label: "SL",
      options: { display: true },
    },
    //16
    {
      name: "SLI",
      label: "SLI",
      options: { display: true },
    },
    //17
    {
      //name: "LI",
      name: "LL",
      label: "LL",
      options: { display: true },
    },
    //18
    {
      name: "LLI",
      label: "LLI",
      options: { display: true },
    },
    //19
    {
      name: "AL",
      label: "AL",
      options: { display: true },
    },
    //20
    {
      name: "ALI",
      label: "ALI",
      options: { display: true },
    },
    //21
    {
      name: "PI",
      label: "PI",
      options: { display: true },
    },
    //22
    {
      name: "SC",
      label: "SC",
      options: { display: true },
    },
    //23
    {
      name: "OD",
      label: "OD",
      options: { display: true },
    },
    //24
    {
      name: "ExcessRecovery",
      label: "Excess Recovery",
      options: { display: true },
    },
    //25
    {
      name: "ShortRecovery",
      label: "Short Recovery",
      options: { display: true },
    },
    //26
    {
      name: "SuretyRecovery",
      label: "Surety Recovery",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //27
    {
      name: "MonthlyCont",
      label: "Monthly Count",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //28
    {
      name: "CGST",
      label: "CGST",
      options: {
        display: true,
      },
    }, //29
    {
      name: "SGST",
      label: "SGST",
      options: {
        display: true,
      },
    },
    //30
    {
      name: "IGST",
      label: "IGST",
      options: {
        display: true,
      },
    },
    //31
    // {
    //   name: "CompanyCuttOff",
    //   label: "Company Cutoff",
    //   options: {
    //     display: true,
    //   },
    // },
    //32
    // {
    //   name: "StatusOfDemand",
    //   label: "Status For Demand",
    //   options: {
    //     display: true,
    //   },
    // },
    //33
    // {
    //   name: "FinancialYear",
    //   label: "Financial Year",
    //   options: {
    //     display: true,
    //   },
    // },
    //34
    {
      name: "RecoveredAmount",
      label: "Recoverable Amount",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //35
    {
      name: "Balance",
      label: "Balance",
      options: {
        display: true,
      },
    },
    //36
    // {
    //   name: "Action",
    //   label: "Action",
    //   options: {
    //     display: context?.CurrentRoleId === RoleEnum.Admin,
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value: any, tableMeta: any) => {
    //       // memberId: tableMeta.rowData[37];
    //       return (
    //         <>
    //           <Tooltip title="View">
    //             <a
    //               onClick={(e) => {
    //                 e.preventDefault();

    //                 if (
    //                   context?.CurrentRoleId === RoleEnum.Admin ||
    //                   RoleEnum.Member
    //                 ) {
    //                   navigate("/DemandRecoveryForm", {
    //                     state: {
    //                       memberId: tableMeta.rowData[37],
    //                     },
    //                   });
    //                 }
    //               }}
    //             >
    //               <i className="fas fa-eye"></i>
    //             </a>
    //           </Tooltip>
    //         </>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "Action",
    //   label: "Action",
    //   options: {
    //     display: context?.CurrentRoleId === RoleEnum.Member,
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value: any, tableMeta: any) => {
    //       return (
    //         <>
    //           <Tooltip title="View">
    //             <a
    //               onClick={(e) => {
    //                 e.preventDefault();

    //                 if (
    //                   context?.CurrentRoleId === RoleEnum.Admin ||
    //                   RoleEnum.Member
    //                 ) {
    //                   navigate("/DemandRecoveryForm", {
    //                     state: {
    //                       // Id: id,
    //                       // currentStatus: currentStatus,
    //                       // RequestId: RequestId,
    //                       // DocUrl: DocUrl,
    //                       // TypeOfTransactionId: TypeOfTransactionId,
    //                       // reqId: reqId,
    //                       // mode: "Edit",
    //                     },
    //                   });
    //                 }
    //               }}
    //             >
    //               <i className="fas fa-eye"></i>
    //             </a>
    //           </Tooltip>
    //         </>
    //       );
    //     },
    //   },
    // },
    //37
    {
      name: "MemberId",
      label: "MemberId",
      options: {
        display: false,
      },
    },
  ];

  const HistoryOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: historyCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const HistoryGridColumns = [
    {
      name: "Sm_Name",
      label: "Status",
      options: {
        display: true,
      },
    },
    {
      name: "Lph_ModifiedBy",
      label: "ModifiedBy",
      options: {
        display: true,
      },
    },
    {
      name: "Lph_CreatedBy",
      label: "CreatedBy",
      options: {
        display: true,
      },
    },
    {
      name: "Lph_CreatedDate",
      label: "Created Date",
      options: {
        display: true,
        ...CommonCellOptions(true),
      },
    },
    {
      name: "Lph_ModifiedDate",
      label: "Modified Date",
      options: {
        display: true,
        ...CommonCellOptions(true),
      },
    },
  ];

  useEffect(() => {
    if (activeTab != null) {
      // if (activeTab.module === LoanDashboardModules.Agreement) {
      //   setDashboardData([]);
      // } else {
      getDashboardData();
      //}
    }
  }, [activeTab, start, sortColumn, sortDirection, searchText, currentFilters]);

  const openModal = async (Id: any, Mode: string) => {
    showLoader();
    try {
      let obj = {
        start: historyStart,
        resultsPerPage: historyPageSize,
        sortColumn: historySortColumn,
        sortDirection: historySortDirection,
        LoanRequestId: Id,
      };

      const resp = await APICall(getRePaymentHistory, obj);

      if (resp?.Data?.length > 0) {
        setDashboardHistoryData(resp?.Data);
      } else {
        setDashboardHistoryData([]);
      }

      const dataCount = resp?.Data[0]?.TotalCount || resp?.Data?.length || 0;
      setHistoryCount(dataCount);
      setModalIsOpen(true);
    } catch (err) {
      notify(ToastType.Error, "Data Not Available");
    
    } finally {
      hideLoader();
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const customStyles = {
    content: {
      width: "70%", // Set the width of the modal
      height: "auto", // Set the height of the modal
      margin: "auto", // Center the modal horizontally
      overflow: "auto", // Allow modal content to be scrollable if needed
    },
  };

  return (
    <div>
      <DynamicGrid
        options={Options}
        data={dashboardData}
        columns={GridColumns}
      />

      {/* <div> */}
      {/* <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
          style={customStyles} // Apply the custom styles
        > */}
      {/* Header */}
      {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h2>Loan Repayment History Data</h2>
           
          </div> */}

      {/* <DynamicGrid
            options={HistoryOptions}
            data={dashboardHistoryData}
            columns={HistoryGridColumns}
          /> */}
      {/* Footer */}
      {/* <div
            style={{
              padding: "10px",
              borderTop: "1px solid #ccc",
              textAlign: "right",
            }}
          >
            <button className="btn btn-cancel" onClick={closeModal}>
              Cancel
            </button>
          </div> */}
      {/* <div>
            <button onClick={closeModal}>Close Modal</button>
          </div> */}
      {/* </Modal> */}
      {/* </div> */}
    </div>
  );
};

export default DRRGrid;
